<template>
    <div class="question-trees">
        <p class="nav-title">{{ $t("zhiji.knowlege.FAQ") }} <GameInfo class="game-info" /></p>
        <div class="tree-search-input">
            <el-input v-model="valueSearch" :placeholder="$t('zhiji.knowlege.sceneSearch')" @input="showSearchList"></el-input>
        </div>
        <EditTree
            class="trees-container"
            :datas="valueSearch == '' ? treeData : { children: resDataSearch, id: '-1', label: '全部分类' }"
            :editable="true"
            :maxLevel="3"
            type="question"
            @nodeSelected="treeSelect"
            @nodeExpanded="treeExpand"
            @nodeOperate="treeOperate"
        />
    </div>
</template>

<script>
import ConditionSearch from "@/views/zhiji/bComponents/inputs/ConditionSearch";
import EditTree from "@/views/zhiji/bComponents/trees/EditTree";
import AddClassification from "./AddClassification";
import GameInfo from "@/views/zhiji/components/gameInfo/GameInfo";
import { filterTreeData, updataTreeData, getParentTree, isArabicText } from "@/views/zhiji/js/common/util.js";
import i18n from "@/i18n";

export default {
    name: "QuestionTrees",
    components: {
        ConditionSearch,
        EditTree,
        GameInfo
    },
    data() {
        return {
            resData: [],
            resDataSearch: [],
            valueSearch: "",
            currentUrl: ""
        };
    },
    computed: {
        treeData() {
            return this.$store.state.zhiji.questionListPage.treeData;
        },
        sceneHolder() {
            return this.$t("zhiji.knowlege.sceneSearch");
        }
    },
    watch: {
        // 监控中英文切换，重新从后台取对应语言数据
        sceneHolder() {
            this.$store.dispatch("zhiji/getTreesData");
        }
    },
    mounted() {
        this.$store.dispatch("zhiji/getTreesData");
    },
    methods: {
        showSearchList(data) {
            this.resData = filterTreeData(this.treeData.children, data, true);
            if (data == "") {
                this.resDataSearch = this.treeData.children;
                return;
            }
            this.conditionInputChange();
        },
        conditionInputChange() {
            this.resDataSearch = this.treeData.children;
            this.currentUrl = this.resData.flatMap(v => {
                const result = getParentTree(this.treeData.children, v, true);
                return result.map(result => result.path);
            });

            const currentindex = this.currentUrl.map(item => item.split("/")[0]).filter((value, index, self) => self.indexOf(value) === index);

            this.resDataSearch = [];
            this.treeData.children.forEach(val => {
                currentindex.forEach(v => {
                    if (v.split("/")[0] === val.id) {
                        this.resDataSearch.push(val);
                    }
                });
            });
        },
        treeSelect(data) {
            this.$store.commit("zhiji/sortIdChange", data);
            if (data.isRoot) {
                this.$store.dispatch("zhiji/getTreesData");
                this.$store.dispatch("zhiji/queryQuestionList", { classId: "", page: 1 });
                this.$store.dispatch("zhiji/queryExtQuestionTotal", { classId: "", page: 1 });
                this.$store.dispatch("zhiji/queryAnswersTotal", { classId: "", page: 1 });
            } else if (this.treeData.children) {
                updataTreeData(this.treeData.children, data.path.split("/"), treeData => {
                    this.$store.dispatch("zhiji/queryQuestionList", { classId: parseInt(treeData.id), page: 1 });
                    this.$store.dispatch("zhiji/queryExtQuestionTotal", { classId: parseInt(treeData.id), page: 1 });
                    this.$store.dispatch("zhiji/queryAnswersTotal", { classId: parseInt(treeData.id), page: 1 });
                });
            }
            this.$emit("selectClick", data);
        },
        treeExpand() {},
        treeOperate(data) {
            if (data.opr === "edit") {
                if (data.level === 1) {
                    // 一级标签编辑时打开弹窗
                    this.$store.dispatch("zhiji/showModal", {
                        type: AddClassification,
                        data: data
                    });
                    return;
                }
                updataTreeData(this.treeData.children, data.path.split("/"), treeData => {
                    treeData.label = data.newLabel;
                    this.$store.dispatch("zhiji/updateQuestionTrees", treeData);
                });
            }

            if (data.opr === "delete") {
                this.$store.dispatch("zhiji/showModal", {
                    type: "MessageModal",
                    data: {
                        type: "tip",
                        message: i18n.t("zhiji.common.deleteConfim") + data.label + "？",
                        confirm: () => {
                            updataTreeData(this.treeData.children, data.path.split("/"), treeData => {
                                this.$store.dispatch("zhiji/deleteQuestionTrees", treeData);
                            });
                        }
                    }
                });
            }

            if (data.opr === "add") {
                this.$store.dispatch("zhiji/showModal", {
                    type: AddClassification,
                    data: data
                });
            }

            if (data.opr === "transfer") {
                updataTreeData(this.treeData.children, data.path.split("/"), treeData => {
                    this.$store.dispatch("zhiji/moveQuestionTrees", {
                        classId: treeData.id,
                        order: data.newIdx
                    });
                });
            }
        }
    }
};
</script>

<style lang="less" scoped>
.question-trees {
    width: 272px;
    padding: 12px 0;
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    border-right: 1px solid #e3ecf5;
    background: #f2f7fd;
    overflow-x: hidden;
    overflow-y: auto;

    .nav-title {
        margin: 0 8px 10px 15px;
        font-size: 14px;
        position: relative;
        font-weight: bold;
        .game-info {
            position: absolute;
            right: 0px;
            top: 0px;
            width: 248px;
        }
    }
    .tree-search-input {
        margin: 0 10px 10px 16px;
        position: relative;
    }
    .trees-container {
        height: calc(100% - 84px);
    }
}
.rtl {
    direction: rtl;
}
</style>
